import React from 'react'
import { useDrawerDetailTheme } from '../../DrawerDetailContext'
import './DrawerDetailText.css'

const DrawerDetailText = ({ children, type, textSize = 12 }: { children: string | string[], type: "bold" | "normal", textSize?: number }) => {
    const { color } = useDrawerDetailTheme()

    return (
        <span style={{ fontSize: textSize, color }} className={type === "bold" ? "drawer-detail__text__bold" : "drawer-detail__text__normal"}>{children}</span>
    )
}

export default DrawerDetailText